import { FC } from "react";

import Box from "@mui/material/Box";
import { useRouter } from "next/router";

interface GiftCardBadgeProps {
  amount: string;
  locale?: string;
}

export const GiftCardBadge: FC<GiftCardBadgeProps> = ({ amount, locale: localeProp }) => {
  const router = useRouter();
  const locale = localeProp ?? router.locale ?? "en";
  const isFr = locale.startsWith("fr");

  return (
    <Box sx={{ position: "relative", width: 105, height: 100 }}>
      <Box component="svg" viewBox="0 0 93 78" sx={{ position: "absolute", top: 22, left: 0, width: 93, height: 78 }}>
        <path
          d="M0 48C0 57 6.2 68.2 24.8 74.8C57.6 82.5 77.6 69.5 86.3 51.4C97 29.3 97.6 0 56.9 0C30.6 0 0 10.1 0 48Z"
          fill="#09CFAF"
        />
      </Box>
      <Box
        component="span"
        sx={{
          position: "absolute",
          top: 38,
          left: 17,
          fontFamily: "Poppins, sans-serif",
          fontWeight: 600,
          fontSize: 34,
          color: "white",
          letterSpacing: "-1.7px",
          lineHeight: 1.3,
        }}
      >
        {isFr ? `${amount}$` : `$${amount}`}
      </Box>
      <Box component="svg" viewBox="0 0 24 27" sx={{ position: "absolute", top: 0, left: 73, width: 29, height: 31 }}>
        <path
          d="M1.67 5.49C3.18 4.06 6 6.89 7.23 8.48C7.72 6.97 9.31 3.95 11.84 3.98C14.36 4 11.27 12.37 9.41 16.55C4 13.78 -0.21 7.29 1.67 5.49Z"
          fill="#84E7D7"
        />
        <path
          d="M16.59 16.19C18.17 15.94 18.71 19.07 18.78 20.67C19.75 19.91 22.09 18.67 23.67 19.84C25.25 21 19.61 25.04 16.59 26.92C14.4 22.65 14.61 16.51 16.59 16.19Z"
          fill="#09CFAF"
        />
      </Box>
    </Box>
  );
};
